import Benefits from "@components/Partners/Benefits";
import Outcomes from "@components/Partners/Outcomes";
import TestimonialSlider from "@components/TestimonialSlider";
import {NextPage} from "next";
import {useTranslation} from "@i18n/client";
import React from "react";

import Layout from "../components/v5/Layout";
import Contact from "../components/v5/Partners/Contact";
import Hero from "../components/v5/Partners/Hero";
import {usePartnersConstants} from "../constants/Partners";
import {localeServerSideProps} from "@i18n/pages";

const Partners: NextPage = () => {
  const i18n = useTranslation();
  const {testimonials} = usePartnersConstants();

  return (
    <Layout
      pageTitle={i18n.t("How to Partner with Carbon Health")}
      pageDescription={i18n.t(
        "Carbon Health is partnering with hospitals, specialists, and medical groups to reimagine how healthcare is delivered.",
      )}
      pageImage="partners"
      ogAlt={i18n.t(
        "Carbon Health is reimagining healthcare with hospitals, specialists, and medical groups.",
      )}
    >
      <Hero />
      <Contact />
      <Benefits />
      <Outcomes />
      <TestimonialSlider
        defaultTestimons={testimonials}
        ariaLabel={i18n.t("A Testimonial from our partner")}
      />
    </Layout>
  );
};

export const getServerSideProps = localeServerSideProps();

export default Partners;
